import React, { useRef, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Pagination, Navigation, Thumbs, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/autoplay';

const Swiperslider = ({ 
  children, 
  spaceBetween, 
  slidesPerView, 
  navigation, 
  pagination, 
  timeDelay, 
  centeredSlides, 
  tabsliderperview, 
  smallsliderperview, 
  mobsliderperview, 
  tabspaceBetween,
  slidesPerGroup,
  mobslidesPerGroup
}) => {
  const swiperRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const swiperModules = [Pagination, Navigation, Thumbs, Autoplay];
  if (slidesPerView === 1) {
    swiperModules.push(EffectFade);
  }

  useEffect(() => {
    const currentRef = swiperRef.current; // Store current ref in a variable

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef); // Use the stored ref variable here
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (swiperInstance?.autoplay) {
      if (isVisible) {
        swiperInstance.autoplay.start();
      } else {
        swiperInstance.autoplay.stop();
      }
    }
  }, [isVisible, swiperInstance]);

  return (
    <div ref={swiperRef} className='col-12 float-start'>
      <Swiper
        loop={false}
        pagination={pagination}
        navigation={navigation}
        autoplay={isVisible ? { delay: timeDelay, disableOnInteraction: false } : false}
        effect={slidesPerView === 1 ? 'fade' : 'slide'}
        modules={swiperModules}
        centeredSlides={centeredSlides}
        onSwiper={setSwiperInstance}
        className='h-100'
        breakpoints={{
          420: {
            slidesPerView: mobsliderperview,
          },
          640: {
            slidesPerView: smallsliderperview,
          },
          768: {
            slidesPerView: tabsliderperview,
            spaceBetween: tabspaceBetween,
            ...(mobslidesPerGroup && { slidesPerGroup: mobslidesPerGroup }),
          },
          1024: {
            slidesPerView: slidesPerView,
            spaceBetween: spaceBetween,
            ...(slidesPerGroup && { slidesPerGroup }),
          },
        }}
      >
        {React.Children.map(children, (child, index) => (
          <SwiperSlide key={index}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Swiperslider;
